import React, { useState, useEffect, useRef } from "react";
import { __ } from "services/Translator";
import { Collapse, Dropdown } from "react-bootstrap";
import api from "services/api";
import { Link, useParams, useHistory, useLocation } from "react-router-dom";

export default function GamesFilter(props) {
  const history = useHistory();
  const [searchStr, setSearchStr] = useState("");
  const [searchSuggestions, setSearchSuggestions] = useState([]);
  const searchTextBox = useRef(null);
  const location = useLocation();

  // expand searcbar
  const [expandSearchBar, setExpandSearchBar] = useState(true);

  const toggleExpandedSearchBar = (force) => {
    if (expandSearchBar) {
      setSearchSuggestions([]);
      if (force === true) {
        setSearchStr("");
        setExpandSearchBar(false);
      } else {
        if (searchStr.length === 0) {
          setExpandSearchBar(false);
        }
      }
    } else {
      setExpandSearchBar(true);
      searchTextBox.current.focus();
    }
  };

  const getSearchSuggestions = async () => {
    if (searchStr.length >= 2) {
      var response = await api.get("/games/search-suggestions", {
        query: searchStr,
        // providers: props.selectedProviders,
        providers: [],
        extensiveInfo: true,
      });
      if (response.status === 200) {
        setSearchSuggestions(response.data);
      }
    } else {
      setSearchSuggestions([]);
    }
  };

  useEffect(() => {
    getSearchSuggestions();
  }, [searchStr]);

  const doSearchByGameName = (text) => {
    props.setSearchStr(text);
    toggleExpandedSearchBar(true);
    props.setSelectedProviders([]);
    history.push("/games/search");
  };

  const params = useParams();
  const gamesCategory = params.category;
  return (
    <>
      <section className="games_filter">
        <div className="container">
          <div className="search_bar">
            <input
              placeholder={__("Search Here...")}
              value={searchStr}
              onChange={(ev) => setSearchStr(ev.target.value)}
              type="text"
              className="searchbox_searchgames"
              ref={searchTextBox}
            />

            <div
              onClick={() => toggleExpandedSearchBar(true)}
              className="search_btn"
            >
              <i className="far fa-search"></i>
            </div>
          </div>
          {searchSuggestions.length > 0 && (
            <Collapse style={{ zIndex: 3050 }} in={!!searchSuggestions.length}>
              <>
                <div className="search_game_lists">
                  <div
                    onClick={() => {
                      setSearchSuggestions([]);
                      setSearchStr("");
                    }}
                    className="close_btn"
                  >
                    <i class="far fa-times text-danger"></i>
                  </div>
                  <div className="games_lists ">
                    {searchSuggestions.map((item, index) => (
                      <div
                        className="single_game"
                        onClick={() => doSearchByGameName(item.game_name)}
                        key={index}
                      >
                        <div className="games_image">
                          <img
                            src={item.game_snapshot_url}
                            onError={(event) =>
                              (event.target.parentElement.style.display =
                                "none")
                            }
                          />
                        </div>
                        <div className="game_overlay">
                          <Dropdown.Item
                            to={"/play/" + item.slug}
                            className={"gameplay_btn " + props.landingType}
                          >
                            {__("Play Now")}
                          </Dropdown.Item>
                          <div className="game_text">
                            <div className="game_name">{item.game_name}</div>
                            <div className="game_provider">
                              {item.provider?.name ?? "N/A"}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </>
            </Collapse>
          )}
          {props.gameDropdown != false && (
            <>
              <div className="games_filter_btns">
                {/* <div className="item_index">{__("Select Category")}</div> */}
                <ul className="gameMenu">
                  <li>
                    <Link
                      className={
                        location.pathname == "/games/all" ? "active" : ""
                      }
                      to="/games/all"
                    >
                      <div className="icon allGamesIcon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          viewBox="0 0 1200 1200"
                        >
                          <path
                            d="m600 0c-331.33 0-600 268.67-600 600 0 331.4 268.67 600 600 600 331.4 0 600-268.6 600-600 0-331.33-268.6-600-600-600m351.54 560.8-181.93 126.27 70.465 212.8c10.734 32.531-26.199 59.668-53.734 39.598l-186.2-135.73-186.27 133.93c-27.602 19.867-64.332-7.5352-53.535-39.934l70.336-210.73-182.2-126.27c-28.199-19.668-14.332-62.535 19.934-62.535h227l71.469-220c10.598-32.332 55.934-32.801 66.531-0.46484l71.469 220.46h226.8c34.266 0 48.133 42.934 19.867 62.602"
                            fill-rule="evenodd"
                          />
                        </svg>
                      </div>
                      <div className="text">{__("All Games")}</div>
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={
                        location.pathname == "/games/slots" ? "active" : ""
                      }
                      to="/games/slots"
                    >
                      <div className="icon slotsIcon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          viewBox="164.05 138.28 872.45 923.42"
                        >
                          <path d="m214.51 1061.7h558.46c13.66 0.12891 26.809-5.168 36.566-14.727 9.7539-9.5586 15.316-22.602 15.465-36.258v-40.422h-660.94v40.422c-0.21484 13.492 5.0117 26.504 14.504 36.098 9.4922 9.5938 22.445 14.957 35.941 14.887z" />
                          <path d="m419.53 440.62h150v225h-150z" />
                          <path d="m607.03 440.62h128.91v225h-128.91z" />
                          <path d="m253.12 440.62h128.91v225h-128.91z" />
                          <path d="m862.5 515.62h121.88v180.47h-121.88z" />
                          <path d="m825 189.27c-0.14844-13.656-5.7109-26.699-15.465-36.258-9.7578-9.5586-22.906-14.855-36.566-14.727h-558.46c-13.496-0.070312-26.449 5.293-35.941 14.887-9.4922 9.5938-14.719 22.605-14.504 36.098v743.55h660.94zm-591.01 122.45h519.49c6.6992 0 12.887 3.5742 16.238 9.375 3.3477 5.8008 3.3477 12.949 0 18.75-3.3516 5.8008-9.5391 9.375-16.238 9.375h-519.49c-6.6992 0-12.887-3.5742-16.238-9.375-3.3477-5.8008-3.3477-12.949 0-18.75 3.3516-5.8008 9.5391-9.375 16.238-9.375zm519.49 482.81h-519.49c-6.6992 0-12.887-3.5742-16.238-9.375-3.3477-5.8008-3.3477-12.949 0-18.75 3.3516-5.8008 9.5391-9.375 16.238-9.375h519.49c6.6992 0 12.887 3.5742 16.238 9.375 3.3477 5.8008 3.3477 12.949 0 18.75-3.3516 5.8008-9.5391 9.375-16.238 9.375zm19.961-110.16c0 4.9727-1.9766 9.7422-5.4922 13.258-3.5156 3.5156-8.2852 5.4922-13.258 5.4922h-520.31c-4.9727 0-9.7422-1.9766-13.258-5.4922-3.5156-3.5156-5.4922-8.2852-5.4922-13.258v-262.5c0-4.9727 1.9766-9.7422 5.4922-13.258 3.5156-3.5156 8.2852-5.4922 13.258-5.4922h520.31c4.9727 0 9.7422 1.9766 13.258 5.4922 3.5156 3.5156 5.4922 8.2852 5.4922 13.258z" />
                          <path d="m935.16 297.71v196.82h37.5v-195.3c35.156-7.2969 63.84-39.555 63.84-78.133 0.019531-19.875-7.3906-39.039-20.777-53.73-13.383-14.691-31.773-23.855-51.562-25.688-19.793-1.8281-39.551 3.8008-55.406 15.785-15.852 11.988-26.656 29.465-30.285 49.004-3.6328 19.543 0.16797 39.734 10.656 56.613 10.488 16.883 26.91 29.234 46.035 34.637z" />
                        </svg>
                      </div>
                      <div className="text">{__("Slots")}</div>
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={
                        location.pathname == "/games/table-games"
                          ? "active"
                          : ""
                      }
                      to="/games/table-games"
                    >
                      <div className="icon tableGamesIcon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          viewBox="150 94.31 900 1008.49"
                        >
                          <path d="m1005 314.21-360-207.84c-27.852-16.078-62.148-16.078-90 0l-360 207.84c-6.9727 4.0195-13.262 8.8906-18.793 14.449l423.79 244.67 423.79-244.67c-5.5312-5.5547-11.82-10.43-18.793-14.449zm-354.68 31.859c-27.648 16.066-72.562 16.066-100.38 0-27.828-16.066-28.117-42.168-0.48047-58.234 27.648-16.066 72.863-16.066 100.68 0 27.828 16.066 27.816 42.168 0.17969 58.234z" />
                          <path d="m153.5 367.52c-2.2578 7.9062-3.5039 16.176-3.5039 24.625v415.69c0 32.148 17.148 61.859 45 77.941l360 207.85c7.1406 4.1289 14.723 7.1523 22.5 9.168v-490.5zm97.859 255.17c-23.293-13.441-41.977-45.816-41.902-72.574 0.070312-26.578 18.887-37.309 42.18-23.855 23.137 13.355 41.832 45.73 41.746 72.312-0.070313 26.762-18.887 37.477-42.023 24.121zm101.06 178.32c-23.293-13.441-41.977-45.816-41.902-72.574 0.070312-26.578 18.887-37.309 42.168-23.855 23.137 13.355 41.832 45.73 41.746 72.312-0.070312 26.762-18.887 37.477-42.023 24.121zm101.06 178.32c-23.293-13.441-41.977-45.816-41.902-72.574 0.070312-26.578 18.887-37.309 42.18-23.855 23.137 13.355 41.832 45.73 41.746 72.312-0.070313 26.762-18.887 37.477-42.023 24.121z" />
                          <path d="m1046.5 367.52-424 244.78v490.5c7.7773-2.0039 15.359-5.0391 22.5-9.168l360-207.85c27.852-16.078 45-45.793 45-77.941v-415.69c0-8.4492-1.2461-16.715-3.5039-24.625zm-283.46 266.47c23.293-13.441 42.098-2.7227 42.18 24.035 0.070312 26.578-18.613 58.957-41.902 72.395-23.137 13.355-42.098 2.7227-42.18-23.855-0.070312-26.762 18.77-59.219 41.902-72.574zm0.81641 289.48c-23.137 13.355-42.098 2.7227-42.168-23.855-0.070313-26.762 18.77-59.219 41.902-72.574 23.293-13.441 42.098-2.7227 42.18 24.035 0.070312 26.578-18.613 58.957-41.902 72.406zm167.18-386.47c23.293-13.441 42.098-2.7227 42.168 24.035 0.070312 26.578-18.613 58.957-41.902 72.395-23.137 13.355-41.953 2.6406-42.023-23.953-0.070313-26.762 18.613-59.137 41.746-72.492zm0.81641 289.48c-23.137 13.355-41.953 2.6406-42.023-23.953-0.070313-26.762 18.613-59.137 41.746-72.492 23.293-13.441 42.098-2.7227 42.168 24.035 0.070313 26.578-18.613 58.957-41.902 72.395z" />
                        </svg>
                      </div>
                      <div className="text">{__("Table Games")}</div>
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={
                        location.pathname == "/games/popular" ? "active" : ""
                      }
                      to="/games/popular"
                    >
                      <div className="icon popularIcon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          viewBox="64.25 127.94 1070.66 944.14"
                        >
                          <path
                            d="m612 223.08c-3.4688 3.5195-8.2617 5.4062-13.199 5.1992-4.9375-0.20312-9.5547-2.4844-12.723-6.2773-78.477-92.641-194.88-111.12-298.08-77.039-65.188 21.562-122.11 62.77-162.96 117.96-44.008 59.746-65.281 133.22-60 207.24 12 171.24 153.24 387 534.96 601.92 381.72-214.92 522.96-430.68 534.12-601.92 5.2812-74.016-15.992-147.49-60-207.24-40.629-55.055-97.238-96.242-162.12-117.96-120-39.48-213.6-9-300 78.117zm-2.5195 788.52c-2.8281 1.8164-6.1172 2.7852-9.4805 2.7852s-6.6523-0.96875-9.4805-2.7852c-326.52-198.6-446.52-390.12-455.04-537.24-4.875-66.453 15.91-132.25 58.078-183.84 39.125-46.949 93.023-79.23 152.88-91.559 46.363-10.082 94.617-7.0977 139.38 8.625 44.77 15.719 84.293 43.559 114.18 80.414 29.84-36.922 69.348-64.828 114.12-80.613 44.77-15.785 93.047-18.828 139.44-8.7852 59.859 12.328 113.76 44.609 152.88 91.559 42.168 51.594 62.953 117.39 58.078 183.84-8.5195 147.48-128.52 339-455.04 537.6z"
                            fill-rule="evenodd"
                          />
                          <path
                            d="m614.4 327c-3.2383 4.7734-8.6289 7.6328-14.398 7.6328s-11.16-2.8594-14.398-7.6328c-24.906-36.973-60.309-65.641-101.65-82.324-41.34-16.68-86.723-20.605-130.31-11.277-52.043 10.648-98.926 38.66-132.96 79.441-36.449 44.816-54.395 101.87-50.16 159.48 7.9219 135.84 120.84 314.52 429.48 504 308.64-189.48 421.56-368.16 429.48-504 4.2344-57.613-13.711-114.66-50.16-159.48-34.035-40.781-80.918-68.793-132.96-79.441-43.59-9.3281-88.973-5.4023-130.31 11.277-41.34 16.684-76.742 45.352-101.65 82.324zm42 63.602c-17.637 67.559 24.723 121.32 63.602 170.76 53.16 67.441 101.04 128.04 22.32 209.52-68.039 70.199-212.88 97.441-285.12 9.3594-14.797-17.652-25.871-38.117-32.551-60.164-6.6836-22.047-8.8359-45.215-6.3281-68.113 6.668-48.684 29.738-93.637 65.398-127.44 3.5977-4.8789 9.3008-7.7617 15.359-7.7617 6.0625 0 11.766 2.8828 15.363 7.7617 15.121 15 17.281 69.48 34.199 97.801 4.3203 7.1992 10.199 11.039 18.602 6 3.7188-2.2812-9.8398-37.078-15-69.961h-0.003907c-3.2656-17.328-5.4688-34.84-6.5977-52.438-0.078125-28.672 8.0938-56.754 23.543-80.906 15.449-24.148 37.52-43.344 63.578-55.297 4.1523-1.8398 8.8555-2.0117 13.129-0.47266 4.2734 1.5391 7.793 4.668 9.8164 8.7383 2.0234 4.0664 2.4023 8.7578 1.0547 13.094z"
                            fill-rule="evenodd"
                          />
                          <path
                            d="m692.64 583.08c-36.961-46.801-76.559-97.078-75.84-161.52-23.047 21.855-36.066 52.242-36 84 0 6.1211 2.8789 25.078 6.2383 46.441 6.8398 43.559 15 96-1.6797 105.48-31.199 18.719-51.961 6.4805-66.719-18.121-11.395-23.613-19.473-48.691-24-74.52-48 58.68-58.078 133.68-9.7188 192 57.359 69.961 178.32 44.762 232.68-11.398 57-58.441 18.238-107.64-24.961-162.36z"
                            fill-rule="evenodd"
                          />
                        </svg>
                      </div>
                      <div className="text">{__("Popular")}</div>
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={
                        location.pathname == "/games/bonus-buy" ? "active" : ""
                      }
                      to="/games/bonus-buy"
                    >
                      <div className="icon bonusBuyIcon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          viewBox="199.85 60.46 800.27 1079.09"
                        >
                          <path
                            d="m806.16 442.39c-104.34 55.008-303.73 51.742-413.86 5.9766-10.98 24.758-29.125 56.785-50.148 93.938-59.242 104.63-142.3 251.29-142.3 372.45 0 124.77 92.953 224.79 407.11 224.79 697.71 0.007813 268.46-478.64 199.19-697.14zm-425.69-74.121c129.07 71.93 332.77 57.863 455.73-20.328-5.9141 143.32-513.41 117.38-489.35-1.7383zm350.95 332.9c11.051-21.648 43.957-4.8359 32.879 16.801l-90.18 175.8c-11.09 21.66-43.945 4.8125-32.879-16.801zm-205.79 0c11.051-21.648 43.957-4.8359 32.879 16.801l-90.18 175.8c-11.09 21.66-43.945 4.8125-32.879-16.801zm31.824-545.84h-262.59c49.066 54.613 97.871 118.54 110.63 184.45 109.93 57 276.17 47.125 384.53-8.0898-5.1094-102.71 29.57-181.69 102.16-271.23h-340.97c44.566 69.469 68.555 141.86 51.445 235.32-4.3789 23.93-40.738 17.27-36.359-6.6602 9.625-52.562 3.8867-96.41-8.8438-133.79z"
                            fill-rule="evenodd"
                          />
                        </svg>
                      </div>
                      <div className="text">{__("Bonus Buy")}</div>
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={
                        location.pathname == "/games/new" ? "active" : ""
                      }
                      to="/games/new"
                    >
                      <div className="icon newIcon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          viewBox="0 0 1200 1200"
                        >
                          <path
                            d="m600 0c-331.33 0-600 268.67-600 600 0 331.4 268.67 600 600 600 331.4 0 600-268.6 600-600 0-331.33-268.6-600-600-600m351.54 560.8-181.93 126.27 70.465 212.8c10.734 32.531-26.199 59.668-53.734 39.598l-186.2-135.73-186.27 133.93c-27.602 19.867-64.332-7.5352-53.535-39.934l70.336-210.73-182.2-126.27c-28.199-19.668-14.332-62.535 19.934-62.535h227l71.469-220c10.598-32.332 55.934-32.801 66.531-0.46484l71.469 220.46h226.8c34.266 0 48.133 42.934 19.867 62.602"
                            fill-rule="evenodd"
                          />
                        </svg>
                      </div>
                      <div className="text">{__("New")}</div>
                    </Link>
                  </li>
                </ul>
                <div className="category_dropdown">
                  <Dropdown className="category_dropdown_body">
                    <Dropdown.Toggle
                      variant="success"
                      className={"dropdown_btn " + props.landingType}
                      id="dropdown-basic1"
                    >
                      <span className="text-capitalize">
                        {props.category == "provably-fair"
                          ? "Provably Fair"
                          : props.category == "live-casino"
                          ? "Live Casino"
                          : props.category == "table-games"
                          ? "Table Games"
                          : props.category == "bonus-buy"
                          ? "Bonus Buy"
                          : props.category}
                      </span>
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="category_dropdown_menu">
                      <Link
                        className={
                          "dropdown-item " +
                          (gamesCategory === "slots"
                            ? "filter_btn active " + props.landingType
                            : "filter_btn " + props.landingType)
                        }
                        to="/games/slots"
                      >
                        <svg className="svg_icon">
                          <use xlinkHref={"/icons.svg#icon-provider-slots"} />
                        </svg>
                        {__("Slots")}
                      </Link>

                      <Link
                        to="/games/popular"
                        className={
                          "dropdown-item " +
                          (gamesCategory === "popular"
                            ? "filter_btn active " + props.landingType
                            : "filter_btn " + props.landingType)
                        }
                      >
                        <svg className="svg_icon">
                          <use xlinkHref={"/icons.svg#icon-fire"} />
                        </svg>
                        {__("Popular")}
                      </Link>

                      <Link
                        to="/games/provably-fair"
                        className={
                          "dropdown-item " +
                          (gamesCategory === "provably-fair"
                            ? "filter_btn active " + props.landingType
                            : "filter_btn " + props.landingType)
                        }
                      >
                        <svg className="svg_icon">
                          <use xlinkHref={"/icons.svg#icon-fire"} />
                        </svg>
                        {__("Provably Fair")}
                      </Link>

                      <Link
                        to="/games/new"
                        className={
                          "dropdown-item " +
                          (gamesCategory === "new"
                            ? "filter_btn active " + props.landingType
                            : "filter_btn " + props.landingType)
                        }
                      >
                        <svg className="svg_icon">
                          <use xlinkHref={"/icons.svg#icon-vip-boost"} />
                        </svg>
                        {__("New")}
                      </Link>

                      <Link
                        to="/games/live-casino"
                        className={
                          "dropdown-item " +
                          (gamesCategory === "live-casino"
                            ? "filter_btn active " + props.landingType
                            : "filter_btn " + props.landingType)
                        }
                      >
                        <svg className="svg_icon">
                          <use
                            xlinkHref={"/icons.svg#icon-provider-live-dealers"}
                          />
                        </svg>
                        {__("Live Casino")}
                      </Link>

                      <Link
                        to="/games/megaways"
                        className={
                          "dropdown-item " +
                          (gamesCategory === "megaways"
                            ? "filter_btn active " + props.landingType
                            : "filter_btn " + props.landingType)
                        }
                      >
                        <svg className="svg_icon">
                          <use xlinkHref={"/icons.svg#icon-stake-exclusive"} />
                        </svg>
                        {__("Megaways")}
                      </Link>

                      <Link
                        to="/games/table-games"
                        className={
                          "dropdown-item " +
                          (gamesCategory === "table-games"
                            ? "filter_btn active " + props.landingType
                            : "filter_btn " + props.landingType)
                        }
                      >
                        <svg className="svg_icon">
                          <use
                            xlinkHref={"/icons.svg#icon-provider-table-game"}
                          />
                        </svg>
                        {__("Table Games")}
                      </Link>

                      <Link
                        to="/games/jackpot"
                        className={
                          "dropdown-item " +
                          (gamesCategory === "jackpot"
                            ? "filter_btn active " + props.landingType
                            : "filter_btn " + props.landingType)
                        }
                      >
                        <svg className="svg_icon">
                          <use xlinkHref={"/icons.svg#icon-stake-exclusive"} />
                        </svg>
                        {__("Jackpot")}
                      </Link>

                      <Link
                        to="/games/bonus-buy"
                        className={
                          "dropdown-item " +
                          (gamesCategory === "bonus-buy"
                            ? "filter_btn active " + props.landingType
                            : "filter_btn " + props.landingType)
                        }
                      >
                        <svg className="svg_icon">
                          <use xlinkHref={"/icons.svg#icon-rewards"} />
                        </svg>
                        {__("Bonus Buy")}
                      </Link>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </>
          )}
        </div>
      </section>
    </>
  );
}
